import React, { useState, useRef } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import useMediaQuery from '@mui/material/useMediaQuery';

const Root = styled('div')(({ theme }) => ({
  flexGrow: 1,
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
  marginLeft: "auto",
  // marginLeft: 0,
  marginRight: 0,
  [theme.breakpoints.up("lg")]: {
    display: "none",
  },
}));

const AppBarMain = styled(AppBar)(({ theme }) => ({
  backgroundColor: "white",
  height: 80,
  padding: "10px 0px",
  boxShadow: theme.shadows[3],
  [theme.breakpoints.down("md")]: {
    padding: "10px 0px",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "14px 0px",
  },
}));

const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  height: 60,
  margin: "0px 95px",
  padding: 0,
  [theme.breakpoints.down("md")]: {
    margin: "0px 32px",
  },
}));

const RightContainer = styled('div')(({ theme }) => ({
  position: "absolute",
  display: 'flex',
  flexDirection: "row",
  alignItems: 'center',
  right: 0,
  [theme.breakpoints.down("md")]: {
    margin: "40px 20px",
    position: "static",
    // width: "50vw",
    display: "flex",
    flexDirection: "column",
    color: "black",
  },
}));

const LinkStyled = styled(Link)(({ theme }) => ({
  position: "relative",
  textAlign: 'center',
  padding: "0px 2vw",
  color: "#FF5A34",
  fontSize: 16,
  fontWeight: "600",
  textDecoration: "none",
  '&:hover': {
    color: "#FF5A34",
  },
  [theme.breakpoints.down("md")]: {
    color: "#606060",
    padding: 10,
    margin: "0 auto",
  },
}));

// const LogoLink = styled(Link)(({ theme }) => ({
//   position: "relative",
//   padding: "0px 0px",
//   color: "#E4223F",
//   fontSize: 16,
//   fontWeight: "600",
//   textAlign: "left",
//   width: "100%",
//   textDecoration: "none",
//   '&:hover': {
//     color: "#FF5A34",
//   },
//   [theme.breakpoints.down("md")]: {
//     color: "#606060",
//     padding: 10,
//     margin: "0 auto 0 0",
//     paddingLeft: "0px",
//   },
// }));

export default function NavBar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isAboutUsDropdownOpen, setIsAboutUsDropdownOpen] = useState(false);
  const aboutUsButtonRef = useRef(null);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const toggleDropdownOpen = (event) => {
    event.preventDefault();
    setIsAboutUsDropdownOpen(prev => !prev);
  };

  const handleDropdownClose = (event) => {
    if (aboutUsButtonRef.current && aboutUsButtonRef.current.contains(event.target)) {
      return;
    }
    setIsAboutUsDropdownOpen(false);
  };

  const navLinks = (
    <RightContainer>
      {["home", "projects", "pokemon"].map((path) => (
        <Box
          key={path}
          sx={{ alignItems: 'center', display: 'flex', marginY: 2 }}
        >
          <LinkStyled
            to={`/${path === "home" ? "home" : path}`}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = `/${path === "home" ? "home" : path}`;
            }}
            sx={{ paddingX: 3 }}
          >
            {path === "pokemon" ? "Pokémon" : path.charAt(0).toUpperCase() + path.slice(1)}
          </LinkStyled>
        </Box>
      ))}
    </RightContainer>
  );

  return (
    <Root>
      <AppBarMain position="fixed">
        <ToolbarStyled>
          <Link
            to="/"
            // className={classes.logoLink}
            style={{ width: 'fit-content', alignItems: 'flex-start' }}
          >
            {/* <p>WRO2021 Randomizer</p> */}
          </Link>
          <MenuButton
            color="default"
            aria-label="Menu"
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </MenuButton>
          {/* Uncomment if you want to show navLinks always on desktop */}
          <>
            {isMdUp ? navLinks : null}
            {/* or */}
            {!isMdUp ? <Drawer>...</Drawer> : null}
          </>
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={toggleDrawer}
          >
            <Box
              tabIndex={0}
              role="button"
              onKeyDown={toggleDrawer}
              sx={{ width: 250, padding: 2 }}
            >
              {navLinks}
            </Box>
          </Drawer>
        </ToolbarStyled>
      </AppBarMain>
    </Root>
  );
}